import React, { forwardRef } from 'react';

import { Control, Tooltip } from '@vlabs/uikit';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { viewerCan } from '@vlabs/pages/auth/selectors';

const ChechboxWithPermissionsComponent = forwardRef(({
  permissions,
  disabled,
  title,
  can,
  ...props
}, externalRef) => {
  const { rules, method = 'oneof' } = permissions;

  const hasPermission = can(rules, { method });
  const isDisabled = !hasPermission || disabled;

  return (
    <Tooltip
      data-tooltip-content={!hasPermission ? i18n.t('кнопка.недостаточно прав.title') : null}
    >
      <Control.Checkbox
        disabled={isDisabled}
        ref={externalRef}
        title={title}
        {...props}
      />
    </Tooltip>
  );
});

ChechboxWithPermissionsComponent.propTypes = {
  permissions: PropTypes.shape({
    rules: PropTypes.arrayOf(PropTypes.string).isRequired,
    method: PropTypes.oneOf(['oneof', 'allof']),
  }),
  disabled: PropTypes.bool,
  can: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ChechboxWithPermissionsComponent.defaultProps = {
  permissions: { rules: [], method: 'oneof' },
  disabled: false,
  title: '',
};

export const ChechboxWithPermissions = connect((state) => ({
  can: viewerCan(state),
}))(ChechboxWithPermissionsComponent);
